module.exports = __webpack_public_path__ + "img/bohemia-lx-se.508b2c16.jpg";